import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';

/**
 * Permissões NOMEADAS do usuário na conta atual (`accounts[].permissions`).
 *
 * `can` responde "esta permissão foi concedida explicitamente", e não "pode fazer isso": o array de
 * um administrador é `['administrator']` e nada mais (ver `AccountUser#permissions`), então
 * `can('inbox_manage')` é FALSO para um administrador. Isso é intencional e é o que o menu precisa:
 * a condição do administrador já existe do lado (`isAdmin`/`isSuperAdmin`) e o que falta é
 * acrescentar a faixa do papel personalizado sem mexer em quem já enxergava a seção.
 *
 * Para "pode fazer isso", some com a condição de papel: `isAdmin.value || can('inbox_manage')`.
 *
 * @returns {{ permissions: import('vue').ComputedRef<string[]>, can: (...required: string[]) => boolean }}
 */
export function usePermissions() {
  const getters = useStoreGetters();

  const permissions = computed(() =>
    getUserPermissions(
      getters.getCurrentUser.value,
      getters.getCurrentAccountId.value
    )
  );

  const can = (...required) =>
    hasPermissions(required.flat(), permissions.value);

  return {
    permissions,
    can,
  };
}
